import { requestToken } from "../api/request_methods";

const API_ROUTE = `${process.env.REACT_APP_NODE_URL}/api/admin`;

class AdminUsersServices {
  async getAllAdminuserData(page, limit, filter) {
    try {
      let action =
        API_ROUTE +
        `/get-all_admin-users?page=${page}&limit=${limit}&filter=${filter}`;
      const response = await requestToken.get(action);
      return response;
    } catch (error) {
      console.error("Errorin getSettingData:", error);
      throw error;
    }
  }

  async addAdminUserData(payload) {
    try {
      let action = API_ROUTE + `/add-admin_user-data`;
      const response = await requestToken.post(action, payload);
      return response;
    } catch (error) {
      console.error("Errorin addAdminUserData:", error);
      throw error;
    }
  }

  async updateAdminUserData(payload) {
    try {
      let action = API_ROUTE + `/update-admin_user-data`;
      const response = await requestToken.post(action, payload);
      return response;
    } catch (error) {
      console.error("Errorin updateAdminUserData:", error);
      throw error;
    }
  }
  async deleteAdminUser(userId) {
    try {
      let action = API_ROUTE + `/delete-admin_user-data?id=${userId}`;
      const response = await requestToken.del(action);
      return response;
    } catch (error) {
      console.error("Errorin deleteAdminUser:", error);
      throw error;
    }
  }

  async toggleAdminStatus(payload) {
    try {
      const action = API_ROUTE + "/update-admin-user-status";
      const response = await requestToken.post(action, payload);
      return response;
    } catch (error) {
      throw error;
    }
  }

  async addAdminWalletBalanceBySA(payload) {
    try {
      const action = API_ROUTE + "/update-admin-wallet";
      const response = await requestToken.post(action, payload);
      return response;
    } catch (error) {
      throw error;
    }
  }

  async assignTemplate(payload) {
    try {
      const action = API_ROUTE + "/assign-template";
      return await requestToken.post(action, payload);
    } catch (error) {
      throw error;
    }
  }

  async addAdminWalletBalanceById() {
    try {
      const action = API_ROUTE + "/get-admin-wallet";
      const response = await requestToken.get(action);
      return response;
    } catch (error) {
      throw error;
    }
  }


}

export default AdminUsersServices;
